import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  updateUserPreferencesService,
} from '@/services/httpServices/PreferenceServices';
import type {
  UpdateUserPreferencesServiceConfig,
} from '@/services/httpServices/PreferenceServices/types';

import { userPreferencesKeys } from '../queries/preferenceQueryKeys';

export function useUpdateUserPreferencesMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (config: UpdateUserPreferencesServiceConfig) => {
      try {
        return await updateUserPreferencesService(config);
      } catch (error) {
        throw new Error(
          error instanceof Error ? error.message : 'Unknown error',
        );
      }
    },
    onSuccess: async (_, variables) => {
      // Invalidate the specific user preferences query
      if (variables.params?.params.id) {
        await queryClient.invalidateQueries({
          queryKey: userPreferencesKeys({
            httpRequestConfig: variables.httpRequestConfig,
            params: { id: variables.params.params.id },
          }),
        });
      }

      // Also invalidate all user preferences queries
      await queryClient.invalidateQueries({
        queryKey: userPreferencesKeys(),
      });
    },
  });
}
